import React from 'react'
import { Container, Stack } from 'react-bootstrap'
import gif from './giphy.gif'


const Loading = ({ link }) => {

    const year = localStorage.getItem('year')
    const linkSubString = link.substring(45)


    return (
        <Container style={{ display: 'flex', alignItems: 'center', height: '100vh', justifyContent: 'center', position: 'absolute', zIndex: '-1' }}>
            <img src={gif} alt="gif" style={{ padding: '3rem' }}></img>
            <Stack gap={3} className="justify-content-center">
                <h2>Taking you to {linkSubString} in {year} please wait..</h2>
                <p>Some Sites may not be Responsive in Mobile View</p></Stack>
        </Container>
    )
}

export default Loading
